/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetSeoUrlsFromQueryStringsModel,
  IGetSeoUrlsFromQueryStringsRequest,
  IMappers,
  IGetSeoUrlsFromQueryStringsResponse,
  IGetSeoUrlsFromQueryStringsResponseError,
  TGetSeoUrlsFromQueryStringsResponse,
} from './types';

const defaultConfig: TGetSeoUrlsFromQueryStringsModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: '/seourls/v2/get-seo-urls-from-query-strings/',
  hostType: 'api',
} as TGetSeoUrlsFromQueryStringsModel;

function createGetSeoUrlsFromQueryStringsModel(
  parameters: IGetSeoUrlsFromQueryStringsRequest,
): TGetSeoUrlsFromQueryStringsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetSeoUrlsFromQueryStringsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetSeoUrlsFromQueryStringsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetSeoUrlsFromQueryStrings<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetSeoUrlsFromQueryStringsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetSeoUrlsFromQueryStringsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetSeoUrlsFromQueryStringsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSeoUrlsFromQueryStringsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetSeoUrlsFromQueryStringsResponseError);
    }
  }

  return { response, statusCode } as TGetSeoUrlsFromQueryStringsResponse;
}

export { defaultConfig, createGetSeoUrlsFromQueryStringsModel, fetchGetSeoUrlsFromQueryStrings };
